import React from 'react';
import { useIntl } from 'react-intl';
import type { AssetPublishConnection, OneOffChannel } from 'fym-shared/src/music24/oneOffPublish';
import { TypedMemo } from '../../../common/types';
import { SettingsAccountRow } from '../composer/settings/SettingsAccountRow';
import { publishMessages } from './publishMessages';
import { ONE_OFF_CHANNEL_NAMES } from './publishBadgeText';

interface PublishChannelRowProps {
  channel: OneOffChannel;
  connection: AssetPublishConnection | null;
}

/**
 * The channel that gets the video: the name and the avatar (the YouTube API terms ask the posting
 * page to show them). Nothing for a manual channel.
 */
const PublishChannelRowComponent: React.FC<PublishChannelRowProps> = ({ channel, connection }) => {
  const intl = useIntl();
  if (connection === null) {
    return null;
  }
  return (
    <SettingsAccountRow
      eyebrow={intl.formatMessage(publishMessages.promptGoesTo)}
      name={connection.displayName ?? ONE_OFF_CHANNEL_NAMES[channel]}
      handle={null}
      avatarUrl={connection.avatarUrl}
    />
  );
};

export const PublishChannelRow = TypedMemo(PublishChannelRowComponent);
